import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=410a6dde&scoped=true"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=410a6dde&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410a6dde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('410a6dde')) {
      api.createRecord('410a6dde', component.options)
    } else {
      api.reload('410a6dde', component.options)
    }
    module.hot.accept("./orderDetails.vue?vue&type=template&id=410a6dde&scoped=true", function () {
      api.rerender('410a6dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components-cool/orderDetails.vue"
export default component.exports